// extracted by mini-css-extract-plugin
module.exports = {"root":"PlaceSection-module--root--2COY1"};